(function () {
  "use strict";

  /* ── Sticky header shadow ─────────────────────────────── */
  var header = document.querySelector(".op76-site-header");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("scrolled", window.scrollY > 8);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ── Mega menu (keyboard + click) ────────────────────── */
  var megaBtn = document.querySelector(".op76-has-mega > button");
  var mega = document.querySelector(".op76-mega");
  if (megaBtn && mega) {
    megaBtn.addEventListener("click", function (e) {
      e.preventDefault();
      var open = mega.classList.toggle("open");
      megaBtn.setAttribute("aria-expanded", open ? "true" : "false");
    });
    document.addEventListener("click", function (e) {
      if (!e.target.closest(".op76-has-mega")) {
        mega.classList.remove("open");
        megaBtn.setAttribute("aria-expanded", "false");
      }
    });
  }

  /* ── "More" dropdown (keyboard + click) ──────────────── */
  var ddItem = document.querySelector(".op76-has-dropdown");
  var ddBtn = ddItem && ddItem.querySelector("button");
  var dd = ddItem && ddItem.querySelector(".op76-dropdown");
  if (ddBtn && dd) {
    ddBtn.addEventListener("click", function (e) {
      e.preventDefault();
      var open = dd.classList.toggle("open");
      ddBtn.setAttribute("aria-expanded", open ? "true" : "false");
    });
    document.addEventListener("click", function (e) {
      if (!e.target.closest(".op76-has-dropdown")) {
        dd.classList.remove("open");
        ddBtn.setAttribute("aria-expanded", "false");
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        dd.classList.remove("open");
        ddBtn.setAttribute("aria-expanded", "false");
      }
    });
  }

  /* ── Mobile panel ────────────────────────────────────── */
  var panel = document.querySelector(".op76-mobile-panel");
  var burger = document.querySelector(".op76-hamburger");
  if (panel && burger) {
    var openPanel = function () {
      panel.classList.add("open");
      burger.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
    };
    var closePanel = function () {
      panel.classList.remove("open");
      burger.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
    };
    burger.addEventListener("click", openPanel);
    panel.querySelectorAll("[data-close]").forEach(function (el) {
      el.addEventListener("click", closePanel);
    });
    panel.querySelectorAll(".m-nav a").forEach(function (a) {
      a.addEventListener("click", closePanel);
    });
    panel.querySelectorAll(".m-nav-toggle").forEach(function (toggle) {
      toggle.addEventListener("click", function () {
        var item = toggle.closest(".m-nav-item");
        var open = item.classList.toggle("open");
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closePanel();
    });
  }

  /* ── FAQ accordion ───────────────────────────────────── */
  document.querySelectorAll(".op76-faq-q").forEach(function (q) {
    q.addEventListener("click", function () {
      var item = q.closest(".op76-faq-item");
      var open = item.classList.toggle("open");
      q.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });

  /* ── Scroll reveal ───────────────────────────────────── */
  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var revealEls = document.querySelectorAll(".op76-reveal:not(.in)");
  if (reducedMotion || !("IntersectionObserver" in window)) {
    revealEls.forEach(function (el) {
      el.classList.add("in");
    });
  } else {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add("in");
            io.unobserve(en.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    revealEls.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ── Hero slider (crossfade, autoplay, dots/arrows) ──── */
  document.querySelectorAll(".op76-hero-slider").forEach(function (hero) {
    var slides = [].slice.call(hero.querySelectorAll(".op76-hero-slide"));
    if (!slides.length) return;

    /* Size the hero box to the active slide's artwork so cover never
       crops it. Liquid already set these for slide 1 — this keeps them
       in sync as slides change. */
    function applyRatio(slide) {
      var ar = slide.getAttribute("data-ar");
      if (ar) {
        hero.style.setProperty("--hero-ar", ar);
        hero.style.setProperty("--hero-ar-m", slide.getAttribute("data-ar-mobile") || ar);
      }
      hero.style.setProperty("--hero-min", slide.getAttribute("data-min") || "0px");
    }

    applyRatio(slides[0]);
    if (slides.length < 2) return;

    var dots = [].slice.call(hero.querySelectorAll(".op76-hero-dot"));
    var prevBtn = hero.querySelector(".op76-hero-arrow.prev");
    var nextBtn = hero.querySelector(".op76-hero-arrow.next");
    var autoplay = !reducedMotion && hero.getAttribute("data-autoplay") === "true";
    var speed = parseInt(hero.getAttribute("data-speed"), 10) || 6000;
    var i = 0;
    var timer = null;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle("active", k === i);
        s.setAttribute("aria-hidden", k === i ? "false" : "true");
      });
      dots.forEach(function (d, k) {
        d.classList.toggle("active", k === i);
        d.setAttribute("aria-selected", k === i ? "true" : "false");
      });
      applyRatio(slides[i]);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function play() {
      if (!autoplay) return;
      stop();
      timer = setInterval(function () { show(i + 1); }, speed);
    }

    dots.forEach(function (d, k) {
      d.addEventListener("click", function () { show(k); play(); });
    });
    if (nextBtn) nextBtn.addEventListener("click", function () { show(i + 1); play(); });
    if (prevBtn) prevBtn.addEventListener("click", function () { show(i - 1); play(); });

    hero.addEventListener("mouseenter", stop);
    hero.addEventListener("mouseleave", play);
    hero.addEventListener("focusin", stop);
    hero.addEventListener("focusout", play);

    play();
  });

  /* ── Announcement bar slider (crossfade, autoplay, dots) */
  document.querySelectorAll(".op76-announce-slider").forEach(function (bar) {
    var slides = [].slice.call(bar.querySelectorAll(".op76-announce-slide"));
    if (slides.length < 2) return;

    var dots = [].slice.call(bar.querySelectorAll(".op76-announce-dot"));
    var autoplay = !reducedMotion && bar.getAttribute("data-autoplay") === "true";
    var speed = parseInt(bar.getAttribute("data-speed"), 10) || 5000;
    var i = 0;
    var timer = null;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle("active", k === i);
        s.setAttribute("aria-hidden", k === i ? "false" : "true");
      });
      dots.forEach(function (d, k) {
        d.classList.toggle("active", k === i);
        d.setAttribute("aria-selected", k === i ? "true" : "false");
      });
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function play() {
      if (!autoplay) return;
      stop();
      timer = setInterval(function () { show(i + 1); }, speed);
    }

    dots.forEach(function (d, k) {
      d.addEventListener("click", function () { show(k); play(); });
    });

    bar.addEventListener("mouseenter", stop);
    bar.addEventListener("mouseleave", play);
    bar.addEventListener("focusin", stop);
    bar.addEventListener("focusout", play);

    play();
  });

  /* ── Cart count (Shopify AJAX) ───────────────────────── */
  // The donation line (Buy Meat. Give Meat.) is added by the theme, not the
  // shopper, so it never counts towards the number on the cart icon.
  function visibleItemCount(cart) {
    var count = cart.item_count;
    (cart.items || []).forEach(function (item) {
      if (item.properties && item.properties["_donation"]) count -= item.quantity;
    });
    return count;
  }

  function updateCartCount(count) {
    var badge = document.querySelector(".op76-cart-count");
    if (!badge) return;
    badge.textContent = count;
    badge.classList.toggle("show", count > 0);
  }

  function fetchCartCount() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(visibleItemCount(cart)); })
      .catch(function () {});
  }

  fetchCartCount();

  document.addEventListener("cart:updated", function (e) {
    if (e.detail && e.detail.cart) updateCartCount(visibleItemCount(e.detail.cart));
  });

  /* ── Late cart additions (Appstle free-gift race) ─────────────
     Appstle's subscription "free gift" line item is added by the app's
     own async call *after* our /cart/add.js response already came back,
     so the drawer's first paint (built from that response) can miss it
     — it only shows up once a later cart mutation forces a fresh section
     fetch. cart-drawer-items already knows how to re-pull its section
     fresh from the server (see onCartUpdate in cart.js); calling that a
     couple of times shortly after every add self-heals the race without
     needing to know Appstle's exact timing.

     This resync fires on a blind timer, so it can race a real edit the
     shopper makes in the meantime (e.g. removing a line item): its GET
     can be in flight when a remove's own POST lands, and if the GET is
     processed server-side *before* the remove, applying it afterwards
     silently resurrects the just-removed line. cartMutationGeneration
     is bumped on every manual cart-items edit (see the updateQuantity
     patch below); resyncCartDrawer snapshots it before fetching and,
     since cart.js's own onCartUpdate() applies its DOM swap *inside*
     its promise chain (too late to veto from outside), this re-fetches
     the section itself so the generation check can run right before
     the replaceWith — a stale pre-removal response is dropped instead
     of clobbering a newer edit. */
  var cartMutationGeneration = 0;
  var CartItemsCtor = customElements.get("cart-items");
  if (CartItemsCtor) {
    var baseUpdateQuantity = CartItemsCtor.prototype.updateQuantity;
    CartItemsCtor.prototype.updateQuantity = function () {
      cartMutationGeneration++;
      return baseUpdateQuantity.apply(this, arguments);
    };
  }

  function resyncCartDrawer() {
    var generationAtStart = cartMutationGeneration;
    fetch(window.routes.cart_url + "?section_id=cart-drawer")
      .then(function (response) { return response.text(); })
      .then(function (responseText) {
        if (cartMutationGeneration !== generationAtStart) return;
        var html = new DOMParser().parseFromString(responseText, "text/html");
        ["cart-drawer-items", ".cart-drawer__footer"].forEach(function (selector) {
          var targetElement = document.querySelector(selector);
          var sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) targetElement.replaceWith(sourceElement);
        });
        fetchCartCount();
      })
      .catch(function () {});
  }

  /* The drawer is the only cart surface most adds happen through, but the
     free-gift sync below can also add or pull a line while the shopper is
     sitting on /cart — where the drawer markup isn't rendered at all. Swap
     whichever of the two surfaces is actually on the page. */
  function resyncCartPage() {
    var cartItems = document.querySelector("cart-items");
    if (!cartItems) return;
    var generationAtStart = cartMutationGeneration;
    Promise.all(
      ["cart-items", "cart-footer"].map(function (sectionId) {
        return fetch(window.routes.cart_url + "?section_id=" + sectionId).then(function (response) {
          return response.text();
        });
      })
    )
      .then(function (responses) {
        if (cartMutationGeneration !== generationAtStart) return;
        var selectors = ["cart-items", "#main-cart-footer"];
        responses.forEach(function (responseText, index) {
          var html = new DOMParser().parseFromString(responseText, "text/html");
          var targetElement = document.querySelector(selectors[index]);
          var sourceElement = html.querySelector(selectors[index]);
          if (targetElement && sourceElement) targetElement.replaceWith(sourceElement);
        });
        fetchCartCount();
      })
      .catch(function () {});
  }

  function resyncCart() {
    resyncCartDrawer();
    resyncCartPage();
  }

  function scheduleResync(delay) {
    var generationAtSchedule = cartMutationGeneration;
    setTimeout(function () {
      if (cartMutationGeneration !== generationAtSchedule) return;
      resyncCartDrawer();
    }, delay);
  }

  /* ── Delivery cadence toggle ──────────────────────────── */
  var cadenceGroup = document.querySelector(".op76-cadence");
  var cadenceNote = document.querySelector(".op76-cadence-note");
  if (cadenceGroup && cadenceNote) {
    var cadenceNotes = {
      Monthly: "Monthly keeps a regular cook stocked. Switch or skip whenever you like.",
      "Bi-Monthly": "Bi-Monthly is an easy pace for smaller households. Switch or skip whenever you like."
    };
    cadenceGroup.querySelectorAll("button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        cadenceGroup.querySelectorAll("button").forEach(function (b) {
          b.classList.remove("active");
        });
        btn.classList.add("active");
        var cad = btn.getAttribute("data-cad");
        cadenceNote.textContent = cadenceNotes[cad] || cadenceNotes.Monthly;
      });
    });
  }

  /* ── Free gift with purchase ───────────────────────────
     Auto-adds settings.free_gift_quantity units of settings.free_gift_
     product (Theme Settings > Cart > "Free gift with purchase") to
     the cart once it holds enough qualifying items, so the gift is
     present for the Buy X Get Y automatic discount (created in Admin)
     to apply. Toggle the "Automatically add free gift product to cart"
     checkbox off to disable — no code changes needed.

     What counts as qualifying comes from two more settings in the same
     group, so a promo change is a Theme Settings edit, not a code edit:

       - "Qualifying collection" — only products in that collection
         count toward the threshold. Leave it empty and any product
         counts, which is the original any-item-adds-the-gift behaviour.
       - "Qualifying items required" — how many of them are needed.

     For the "buy any 2 steaks, get 1 free" promo that means: qualifying
     collection = Steaks, qualifying items required = 2, gift product =
     the steak the Buy X Get Y discount marks down.

     The auto-added line carries a hidden _free_gift line item property
     (leading underscore, so the cart templates don't render it). That's
     what distinguishes the gift from the same product bought
     deliberately at full price, and it's used two ways: a gift line
     never counts toward the threshold that earned it, and if the cart
     later drops back below the threshold only the tagged line is pulled
     out — otherwise the shopper would silently be charged full price
     for a gift the discount no longer applies to.

     "Only once": before adding, the current /cart.js is checked for
     the gift's variant id; if it's already a line item, we no-op.

     Manual removal is respected for the rest of the browser session
     (sessionStorage flag) — if the shopper removes the gift line
     themselves (remove button, or dragging the quantity to 0), it
     won't be silently re-added on their next add-to-cart. The flag
     clears once the cart is completely empty, since that's
     effectively a fresh shopping session. */
  (function () {
    var freeGift = window.OP76FreeGift;
    if (!freeGift || !freeGift.enabled || !freeGift.variantId) return;

    var giftQuantity = parseInt(freeGift.quantity, 10);
    if (!giftQuantity || giftQuantity < 1) giftQuantity = 1;

    var minQuantity = parseInt(freeGift.minQuantity, 10);
    if (!minQuantity || minQuantity < 1) minQuantity = 1;

    // Left null when no qualifying collection is configured, which is the
    // signal that every product in the cart counts toward the threshold.
    var qualifyingIds = null;
    if (freeGift.qualifyingProductIds && freeGift.qualifyingProductIds.length) {
      qualifyingIds = {};
      freeGift.qualifyingProductIds.forEach(function (id) {
        qualifyingIds[id] = true;
      });
    }

    var GIFT_PROPERTY = "_free_gift";
    var DISMISS_KEY = "op76FreeGiftDismissed";
    var giftMutationInFlight = false;

    function giftDismissed() {
      try {
        // Scoped to the current variant id so swapping the configured
        // gift product in Theme Settings doesn't inherit a dismissal
        // recorded against the old product.
        return sessionStorage.getItem(DISMISS_KEY) === String(freeGift.variantId);
      } catch (e) {
        return false;
      }
    }

    function setGiftDismissed(value) {
      try {
        if (value) sessionStorage.setItem(DISMISS_KEY, String(freeGift.variantId));
        else sessionStorage.removeItem(DISMISS_KEY);
      } catch (e) {}
    }

    function isGiftLine(item) {
      return !!(item.properties && item.properties[GIFT_PROPERTY]);
    }

    // The "cheapest item free" promo below tags its own lines. They're
    // somebody else's gift as far as this promo is concerned: they must
    // never count toward this threshold, and must never be mistaken for
    // this promo's own gift line.
    function isOtherPromoGiftLine(item) {
      return !!(item.properties && item.properties["_cheapest_gift"]);
    }

    function findGiftLine(cart) {
      for (var i = 0; i < cart.items.length; i++) {
        if (isGiftLine(cart.items[i])) return cart.items[i];
      }
      return null;
    }

    // Deliberately also true for an untagged line of the gift variant: if
    // the shopper already put that product in the cart themselves, adding a
    // second copy of it on top is not what they'd expect.
    function cartHasGift(cart) {
      return cart.items.some(function (item) {
        if (isOtherPromoGiftLine(item)) return false;
        return isGiftLine(item) || item.id === freeGift.variantId;
      });
    }

    function qualifyingQuantity(cart) {
      return cart.items.reduce(function (total, item) {
        if (isGiftLine(item) || isOtherPromoGiftLine(item)) return total;
        if (item.properties && item.properties["_donation"]) return total;
        if (qualifyingIds && !qualifyingIds[item.product_id]) return total;
        return total + item.quantity;
      }, 0);
    }

    function addGift() {
      var properties = {};
      properties[GIFT_PROPERTY] = "true";

      giftMutationInFlight = true;
      return fetch(window.routes.cart_add_url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [{ id: freeGift.variantId, quantity: giftQuantity, properties: properties }]
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () { resyncCart(); })
        .catch(function () {})
        .finally(function () { giftMutationInFlight = false; });
    }

    function removeGift(line) {
      giftMutationInFlight = true;
      return fetch(window.routes.cart_change_url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: line.key, quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(function () { resyncCart(); })
        .catch(function () {})
        .finally(function () { giftMutationInFlight = false; });
    }

    function syncGift() {
      if (giftMutationInFlight) return;
      fetch("/cart.js")
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.item_count === 0) {
            setGiftDismissed(false);
            return;
          }

          if (qualifyingQuantity(cart) < minQuantity) {
            var giftLine = findGiftLine(cart);
            if (giftLine) return removeGift(giftLine);
            return;
          }

          if (giftDismissed() || cartHasGift(cart)) return;
          return addGift();
        })
        .catch(function () {});
    }

    // Any cart mutation across the site (PDP, quick order list, etc.). In-cart
    // edits are included rather than skipped: dropping a qualifying line from
    // 2 to 1 is exactly the case where the gift has to come back out again.
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, syncGift);
    }

    // This theme's own quick-add tiles (bindQuickAdd below) only dispatch
    // this DOM event, not PUB_SUB_EVENTS.cartUpdate.
    document.addEventListener("cart:updated", syncGift);

    // Respect a manual removal of the gift line via the cart's remove button
    document.addEventListener("click", function (e) {
      var removeBtn = e.target.closest("cart-remove-button");
      if (!removeBtn) return;
      var variantEl = removeBtn.querySelector("[data-variant-id]");
      if (variantEl && String(variantEl.dataset.variantId) === String(freeGift.variantId)) {
        setGiftDismissed(true);
      }
    });

    // ...or by dragging/typing its quantity down to 0
    document.addEventListener("change", function (e) {
      var input = e.target.closest(".quantity__input[data-quantity-variant-id]");
      if (!input) return;
      if (
        String(input.dataset.quantityVariantId) === String(freeGift.variantId) &&
        parseInt(input.value, 10) === 0
      ) {
        setGiftDismissed(true);
      }
    });

    // Catch the case where qualifying items are already in the cart from
    // an earlier page view (e.g. shopper reloads or lands on /cart directly).
    syncGift();
  })();

  /* ── Buy X get Y free, cheapest item free ──────────────
     A second, independent promo (Theme Settings > Cart > "Buy X get Y
     free (cheapest item free)"). Where the free-gift promo above adds
     one *fixed* configured product, this one has no configured product
     at all: once the cart holds settings.cheapest_gift_trigger_quantity
     qualifying items, it adds settings.cheapest_gift_quantity free
     copies of whichever qualifying line in the cart is *cheapest*.

     For the "buy any 3 steaks, get 2 free" promo that means: qualifying
     collection = Steaks, qualifying items required = 3, free items
     given = 2. Three steaks in the cart and the shopper gets two more
     of their lowest-priced one, for five total.

     Steaks are graded, so "the cheapest item" and "the item handed over"
     are two different variants. The gift is given in the configured grade
     (Theme Settings > Cart > "Free variant option value" — Angus), in the
     size the shopper already has: a 16oz Wagyu ribeye earns two 16oz Angus,
     not two 12oz. Cuts not sold in that grade — the single-variant ones —
     give their own cheapest variant, so the shopper always gets something.
     See giftCandidate() below. Which *product* wins is then decided on the
     price of what would be given, not on what the shopper paid.

     Pair it with a Shopify automatic Buy X Get Y discount over the same
     collection ("buys 3 from Steaks, gets 2 from Steaks free"). Shopify
     applies that discount to the lowest-priced eligible lines, which are
     exactly the ones added here, so the added copies are what goes free.

     The added line carries a hidden _cheapest_gift property (leading
     underscore, so cart templates don't render it). Because Shopify
     keeps lines with different properties separate, the two free copies
     sit on their own line even though the shopper is also buying that
     same variant at full price — which is what makes "the cheapest item
     in the cart" a usable gift at all. The tag is used three ways: gift
     lines never count toward the threshold that earned them, they're
     excluded when working out which item is cheapest, and if the cart
     later drops back below the threshold only the tagged line is pulled
     out rather than something the shopper chose.

     The cheapest qualifying item can change as the cart is edited, so
     the gift line is kept in step: add a cheaper steak and the gift is
     swapped over to it. Ties keep the earlier line, so equal-priced
     items don't flip the gift back and forth on every cart update.

     Manual removal is respected for the rest of the browser session
     (sessionStorage flag). Rather than watching for clicks on a
     particular variant's remove button — the gift variant isn't fixed
     here — removal is inferred from the cart itself: a gift line that
     was there a moment ago and is now gone while the cart still
     qualifies was taken out by the shopper. Removals this code performs
     clear that "was there" marker first, so pulling the gift when the
     cart drops below the threshold is never mistaken for a dismissal.
     The flags clear once the cart is completely empty. */
  (function () {
    var promo = window.OP76CheapestGift;
    if (!promo || !promo.enabled) return;

    var minQuantity = parseInt(promo.minQuantity, 10);
    if (!minQuantity || minQuantity < 1) minQuantity = 1;

    var giftQuantity = parseInt(promo.giftQuantity, 10);
    if (!giftQuantity || giftQuantity < 1) giftQuantity = 1;

    /* Per-product variant table built by op76-cheapest-gift-variants.liquid,
       keyed by product id. Null when no qualifying collection is configured,
       which is the signal that every product in the cart counts. */
    var giftVariants = promo.giftVariants || null;

    /* The table's keys are the qualifying set — there is no separate id list
       to fall out of step with it, and products excluded by tag ("not
       steaks") are absent from the table, so they neither count toward the
       threshold nor get given away. Null means every product counts. */
    var qualifyingIds = null;
    if (giftVariants) {
      qualifyingIds = {};
      Object.keys(giftVariants).forEach(function (id) {
        qualifyingIds[id] = true;
      });
    }

    // Blank means the promo isn't grading the gift at all: give back
    // whatever the shopper bought, which is how it behaved before steaks
    // were split into Angus and Wagyu.
    var gradeValue = (promo.gradeValue || "").trim().toLowerCase();

    var GIFT_PROPERTY = "_cheapest_gift";
    var FREE_GIFT_PROPERTY = "_free_gift";
    var DISMISS_KEY = "op76CheapestGiftDismissed";
    var PRESENT_KEY = "op76CheapestGiftPresent";

    /* One pass at a time. Two cart events can land close enough together
       that both read /cart.js before either has written anything — this
       theme's quick-add dispatches cart:updated while Shopify's own cart
       publishes cartUpdate — and without this both passes would see a
       qualifying, giftless cart and each add their own gift line. A pass
       requested mid-flight is collapsed into one re-run at the end, so the
       decision is always made against a settled cart. */
    var syncInFlight = false;
    var syncPending = false;

    function readFlag(key) {
      try {
        return sessionStorage.getItem(key) === "1";
      } catch (e) {
        return false;
      }
    }

    function writeFlag(key, value) {
      try {
        if (value) sessionStorage.setItem(key, "1");
        else sessionStorage.removeItem(key);
      } catch (e) {}
    }

    function isGiftLine(item) {
      return !!(item.properties && item.properties[GIFT_PROPERTY]);
    }

    // Neither promo's gift earns the other promo a gift.
    function isAnyGiftLine(item) {
      return !!(
        item.properties &&
        (item.properties[GIFT_PROPERTY] || item.properties[FREE_GIFT_PROPERTY] || item.properties["_donation"])
      );
    }

    function isQualifying(item) {
      if (isAnyGiftLine(item)) return false;
      if (qualifyingIds && !qualifyingIds[item.product_id]) return false;
      return true;
    }

    function findGiftLine(cart) {
      for (var i = 0; i < cart.items.length; i++) {
        if (isGiftLine(cart.items[i])) return cart.items[i];
      }
      return null;
    }

    function qualifyingQuantity(cart) {
      return cart.items.reduce(function (total, item) {
        return isQualifying(item) ? total + item.quantity : total;
      }, 0);
    }

    /* Variants Shopify refused to add — sold out, or already at the stock
       or per-order cap because the shopper is buying that item too. Kept
       for the page's lifetime so the promo falls through to the next
       cheapest qualifying item and the shopper still gets something,
       instead of retrying a doomed add on every cart update. */
    var unaddable = {};

    /* Resolving a cart line to the variant that would be given for it.

       Steaks are graded — the same cut is sold as Wagyu and as Angus, and on
       three of them (boneless ribeye, filet, NY strip) each grade is sold in
       two sizes as well. The promo gives the Angus, in the size the shopper
       has in their cart: buy a 16oz Wagyu ribeye and the free one is the
       16oz Angus, not the 12oz. Size is matched by comparing every option
       position *except* the grade one, so it works regardless of how many
       size-ish options a product has or what they're named.

       Products that don't offer the grade at all — the single-variant cuts,
       and the Wagyu-only ones — give their own cheapest available variant,
       which for a one-variant product is simply that variant.

       Falls back to the bought line itself when there's nothing to resolve
       against: no qualifying collection configured, no grade value set, a
       product outside the collection, or a product whose variants are all
       unavailable. That's the pre-grade behaviour, so an unconfigured store
       behaves exactly as it did before. */
    function optionsMatchExceptGrade(candidate, bought, gradeIndex) {
      var a = candidate.options;
      var b = bought.options;
      if (!a || !b || a.length !== b.length) return false;
      for (var i = 0; i < a.length; i++) {
        if (i === gradeIndex) continue;
        if (String(a[i]).trim().toLowerCase() !== String(b[i]).trim().toLowerCase()) return false;
      }
      return true;
    }

    function cheapestAvailable(variants) {
      var best = null;
      variants.forEach(function (v) {
        if (!v.available) return;
        if (!best || v.price < best.price) best = v;
      });
      return best;
    }

    function lineAsCandidate(item) {
      return { id: item.id, price: item.price, title: item.product_title };
    }

    function giftCandidate(item) {
      if (!gradeValue) return lineAsCandidate(item);
      var entry = giftVariants && giftVariants[item.product_id];
      if (!entry || !entry.variants || !entry.variants.length) return lineAsCandidate(item);

      var gradeIndex = entry.gradeIndex;
      if (typeof gradeIndex !== "number" || gradeIndex < 0) {
        return cheapestAvailable(entry.variants) || lineAsCandidate(item);
      }

      var bought = null;
      for (var i = 0; i < entry.variants.length; i++) {
        if (entry.variants[i].id === item.id) {
          bought = entry.variants[i];
          break;
        }
      }

      var sizeMatch = null;
      var cheapestGraded = null;
      entry.variants.forEach(function (v) {
        if (!v.available || !v.options) return;
        if (String(v.options[gradeIndex]).trim().toLowerCase() !== gradeValue) return;
        if (!cheapestGraded || v.price < cheapestGraded.price) cheapestGraded = v;
        if (bought && optionsMatchExceptGrade(v, bought, gradeIndex)) {
          if (!sizeMatch || v.price < sizeMatch.price) sizeMatch = v;
        }
      });

      // Cheapest graded variant covers the case where the shopper's size has
      // no counterpart in this grade; the catalog has full parity today, so
      // it's a guard rather than a path that runs.
      return sizeMatch || cheapestGraded || cheapestAvailable(entry.variants) || lineAsCandidate(item);
    }

    /* Ranking is on the price of the variant that would actually be *given*,
       not on the price of the line the shopper bought — with grades those
       are different numbers, and ranking on what leaves the warehouse is
       what keeps the added line the lowest-priced eligible line in the cart.
       That's what makes Shopify's automatic Buy X Get Y discount land on the
       gift rather than on something the shopper paid for.

       Prices are per-unit and in cents *before* discounts — final_price
       would let an unrelated discount decide which item goes free. The
       strict "<" keeps ties on the earlier line, so equal-priced items don't
       flip the gift back and forth on every cart update. Note this only
       picks the gift; an item whose gift variant is unaddable still counts
       toward the threshold, because the shopper did buy it. */
    function cheapestQualifying(cart) {
      var cheapest = null;
      cart.items.forEach(function (item) {
        if (!isQualifying(item)) return;
        var candidate = giftCandidate(item);
        if (!candidate || unaddable[candidate.id]) return;
        if (!cheapest || candidate.price < cheapest.price) cheapest = candidate;
      });
      return cheapest;
    }

    function addPayload(variantId) {
      var properties = {};
      properties[GIFT_PROPERTY] = "true";
      return { items: [{ id: variantId, quantity: giftQuantity, properties: properties }] };
    }

    function postJson(url, body) {
      return fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json();
      });
    }

    // /cart/add.js answers 4xx with a JSON body carrying `status` rather than
    // rejecting, so a sold-out or quantity-capped variant lands here, not in
    // .catch. Treat it as "no gift line now" so the next cart update retries
    // instead of the shopper being marked as having dismissed a gift they
    // never saw.
    function addSucceeded(data) {
      return !(data && data.status);
    }

    function addGift(variantId) {
      var refused = false;
      return postJson(window.routes.cart_add_url + ".js", addPayload(variantId))
        .then(function (data) {
          refused = !addSucceeded(data);
          writeFlag(PRESENT_KEY, !refused);
          // Nothing changed in the cart when the add was refused, so the
          // (three-request) section resync would be wasted work.
          if (!refused) resyncCart();
        })
        .catch(function () {})
        .finally(function () {
          if (refused) {
            unaddable[variantId] = true;
            // Lands as a pending re-run, since the pass that called this is
            // still unwinding; it then picks the next cheapest item.
            syncGift();
          }
        });
    }

    function removeGift(line) {
      return postJson(window.routes.cart_change_url + ".js", { id: line.key, quantity: 0 })
        .then(function () {
          writeFlag(PRESENT_KEY, false);
          resyncCart();
        })
        .catch(function () {});
    }

    // Swapping the gift onto a newly-cheapest item. Remove-then-add rather
    // than a quantity change, because the gift is a different variant.
    function replaceGift(line, variantId) {
      var refused = false;
      return postJson(window.routes.cart_change_url + ".js", { id: line.key, quantity: 0 })
        .then(function () {
          return postJson(window.routes.cart_add_url + ".js", addPayload(variantId));
        })
        .then(function (data) {
          refused = !addSucceeded(data);
          // The old line is gone either way, so PRESENT_KEY has to drop on a
          // refusal — otherwise the retry below would read the missing gift
          // as the shopper having dismissed it.
          writeFlag(PRESENT_KEY, !refused);
          resyncCart();
        })
        .catch(function () {})
        .finally(function () {
          if (refused) {
            unaddable[variantId] = true;
            // Lands as a pending re-run, since the pass that called this is
            // still unwinding; it then picks the next cheapest item.
            syncGift();
          }
        });
    }

    // A part-quantity gift line has no meaning — the Buy X Get Y discount is
    // written for a fixed "get" quantity — so a shopper editing it down is
    // put back. Editing it all the way to 0 removes the line, which is read
    // as a dismissal below and is how they opt out.
    function correctGiftQuantity(line) {
      return postJson(window.routes.cart_change_url + ".js", {
        id: line.key,
        quantity: giftQuantity
      })
        .then(function () {
          resyncCart();
        })
        .catch(function () {});
    }

    function syncGift() {
      if (syncInFlight) {
        syncPending = true;
        return;
      }
      syncInFlight = true;
      // Each branch below returns its mutation's promise, so the pass isn't
      // considered finished — and no queued pass starts — until the cart has
      // actually been written.
      fetch("/cart.js")
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          if (cart.item_count === 0) {
            writeFlag(DISMISS_KEY, false);
            writeFlag(PRESENT_KEY, false);
            return;
          }

          var giftLine = findGiftLine(cart);

          // Recorded from the cart rather than from "we added it", so a gift
          // still sitting in a cart carried over from an earlier session is
          // also removable — otherwise it would be re-added under the
          // shopper every time they took it out.
          if (giftLine) writeFlag(PRESENT_KEY, true);

          if (qualifyingQuantity(cart) < minQuantity) {
            if (giftLine) return removeGift(giftLine);
            return;
          }

          var cheapest = cheapestQualifying(cart);
          if (!cheapest) {
            if (giftLine) return removeGift(giftLine);
            return;
          }

          if (!giftLine) {
            if (readFlag(PRESENT_KEY)) {
              writeFlag(DISMISS_KEY, true);
              writeFlag(PRESENT_KEY, false);
              return;
            }
            if (readFlag(DISMISS_KEY)) return;
            return addGift(cheapest.id);
          }

          if (giftLine.id !== cheapest.id) return replaceGift(giftLine, cheapest.id);
          if (giftLine.quantity !== giftQuantity) return correctGiftQuantity(giftLine);
        })
        .catch(function () {})
        .finally(function () {
          syncInFlight = false;
          if (syncPending) {
            syncPending = false;
            syncGift();
          }
        });
    }

    // Any cart mutation across the site (PDP, quick order list, etc.). In-cart
    // edits are included rather than skipped: dropping a qualifying line is
    // exactly the case where the gift has to come back out, or move to
    // whatever is cheapest now.
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, syncGift);
    }

    // This theme's own quick-add tiles (bindQuickAdd below) only dispatch
    // this DOM event, not PUB_SUB_EVENTS.cartUpdate.
    document.addEventListener("cart:updated", syncGift);

    // Catch the case where qualifying items are already in the cart from
    // an earlier page view (e.g. shopper reloads or lands on /cart directly).
    syncGift();
  })();

  /* ── Buy Meat. Give Meat. donation line ───────────────
     A third, independent promo (Theme Settings > Cart > "Buy Meat. Give
     Meat. (donation)"). Every qualifying item in the cart earns
     settings.donation_lbs_per_item units of a $0, non-shipping donation
     product, added as ONE line whose quantity this code keeps equal to
     (qualifying items x units per item). The line is a record, not a
     shipment: it shows in the cart/drawer and on the order, and the
     product is set up in Admin as non-physical so nothing is fulfilled.

     The line carries a hidden _donation property (leading underscore, so
     cart templates don't render it). It marks the line as ours: it never
     counts towards any promo's threshold, never counts on the cart icon,
     and CSS hides its quantity/remove controls (.cart-item--donation) so
     the shopper can't edit it. Anything they do to the qualifying lines
     is followed by a resync, which also repairs a tampered quantity.

     Unlike the gift promos there is no "dismissed" state — the donation is
     ours to give, not something the shopper opts out of. Outside the
     start/end window (or with the toggle off) the desired quantity is 0,
     so a stale donation line is pulled rather than left behind. With no
     donation product configured this whole block is a no-op. */
  (function () {
    var promo = window.OP76Donation;
    if (!promo || !promo.variantId) return;

    var unitsPerItem = parseInt(promo.unitsPerItem, 10);
    if (!unitsPerItem || unitsPerItem < 1) unitsPerItem = 1;

    var qualifyingIds = null;
    if (promo.qualifyingProductIds && promo.qualifyingProductIds.length) {
      qualifyingIds = {};
      promo.qualifyingProductIds.forEach(function (id) {
        qualifyingIds[id] = true;
      });
    }

    var PROPERTY = "_donation";
    var startsAt = promo.startsAt ? Date.parse(promo.startsAt) : NaN;
    var endsAt = promo.endsAt ? Date.parse(promo.endsAt) : NaN;
    var inFlight = false;
    var pending = false;

    function inWindow() {
      var now = Date.now();
      if (!isNaN(startsAt) && now < startsAt) return false;
      if (!isNaN(endsAt) && now > endsAt) return false;
      return true;
    }

    function isDonationLine(item) {
      return !!(item.properties && item.properties[PROPERTY]);
    }

    // Gift lines from the other promos were given, not purchased.
    function isQualifying(item) {
      if (isDonationLine(item)) return false;
      if (item.properties && (item.properties["_free_gift"] || item.properties["_cheapest_gift"])) return false;
      if (qualifyingIds && !qualifyingIds[item.product_id]) return false;
      return true;
    }

    function desiredQuantity(cart) {
      if (!promo.enabled || !inWindow()) return 0;
      var qualifying = cart.items.reduce(function (total, item) {
        return isQualifying(item) ? total + item.quantity : total;
      }, 0);
      return qualifying * unitsPerItem;
    }

    function findLine(cart) {
      for (var i = 0; i < cart.items.length; i++) {
        if (isDonationLine(cart.items[i])) return cart.items[i];
      }
      return null;
    }

    function postJson(url, body) {
      return fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    }

    function addLine(quantity) {
      var properties = {};
      properties[PROPERTY] = "buy-meat-give-meat";
      return postJson(window.routes.cart_add_url + ".js", {
        items: [{ id: promo.variantId, quantity: quantity, properties: properties }]
      }).then(function () { resyncCart(); });
    }

    function setLineQuantity(line, quantity) {
      return postJson(window.routes.cart_change_url + ".js", { id: line.key, quantity: quantity })
        .then(function () { resyncCart(); });
    }

    function syncDonation() {
      if (inFlight) {
        pending = true;
        return;
      }
      inFlight = true;
      fetch("/cart.js")
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var desired = desiredQuantity(cart);
          var line = findLine(cart);
          if (!line && desired > 0) return addLine(desired);
          if (line && line.quantity !== desired) return setLineQuantity(line, desired);
        })
        .catch(function () {})
        .finally(function () {
          inFlight = false;
          if (pending) {
            pending = false;
            syncDonation();
          }
        });
    }

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, syncDonation);
    }
    document.addEventListener("cart:updated", syncDonation);
    syncDonation();
  })();

  /* ── Buy Meat. Give Meat. campaign chrome + page ───────
     Everything here keys off attributes that only exist while the campaign
     markup does ([data-bmgm-*]), so on any other page it finds nothing and
     does nothing.

     - [data-bmgm-window]: ticker/slide-out are server-rendered inside the
       start/end window, but pages can be cached past it, so re-check here.
     - [data-bmgm-slideout]: opens once per session, 6s after load.
     - [data-bmgm-count]: big counters count up from 0 when scrolled in
       (the real number is already in the markup, so no-JS still shows it).
     - [data-track]: pushes bmgm_* events to dataLayer / gtag / fbq. */
  (function () {
    function windowOpen(el) {
      var start = Date.parse(el.getAttribute("data-starts-at") || "");
      var end = Date.parse(el.getAttribute("data-ends-at") || "");
      var now = Date.now();
      if (!isNaN(start) && now < start) return false;
      if (!isNaN(end) && now > end) return false;
      return true;
    }

    function track(name) {
      var payload = { event: "bmgm_" + name };
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(payload); } catch (e) {}
      try { if (window.gtag) window.gtag("event", "bmgm_" + name); } catch (e) {}
      try { if (window.fbq) window.fbq("trackCustom", "BMGM_" + name); } catch (e) {}
    }

    document.querySelectorAll("[data-bmgm-window]").forEach(function (el) {
      if (!windowOpen(el)) {
        el.hidden = true;
      }
    });

    var slideout = document.querySelector("[data-bmgm-slideout]");
    if (slideout && !slideout.hidden) {
      var SLIDEOUT_KEY = "op76BmgmSlideoutSeen";
      var seen = false;
      try { seen = sessionStorage.getItem(SLIDEOUT_KEY) === "1"; } catch (e) {}
      var dismiss = function () {
        slideout.classList.remove("open");
        try { sessionStorage.setItem(SLIDEOUT_KEY, "1"); } catch (e) {}
      };
      if (!seen) {
        setTimeout(function () {
          slideout.classList.add("open");
          track("slideout_shown");
        }, 6000);
      }
      var closeBtn = slideout.querySelector("[data-bmgm-slideout-close]");
      if (closeBtn) closeBtn.addEventListener("click", dismiss);
      slideout.querySelectorAll("a").forEach(function (a) {
        a.addEventListener("click", dismiss);
      });
    }

    var counters = document.querySelectorAll("[data-bmgm-count]");
    if (counters.length) {
      var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var format = function (n) { return n.toLocaleString("en-US"); };
      var countUp = function (el) {
        var target = parseInt(el.getAttribute("data-bmgm-count"), 10) || 0;
        var duration = 1200;
        var t0 = null;
        var step = function (ts) {
          if (t0 === null) t0 = ts;
          var p = Math.min((ts - t0) / duration, 1);
          el.textContent = format(Math.round(target * (1 - Math.pow(1 - p, 3))));
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      };
      if (!reduceMotion && "IntersectionObserver" in window) {
        var counterObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            counterObserver.unobserve(entry.target);
            countUp(entry.target);
          });
        }, { threshold: 0.4 });
        counters.forEach(function (el) { counterObserver.observe(el); });
      }
    }

    document.addEventListener("click", function (e) {
      var el = e.target.closest("[data-track]");
      if (el) track(el.getAttribute("data-track"));
    });

    if (document.querySelector("[data-bmgm-page]")) track("landing_view");
  })();

  /* ── Quick add-to-cart (AJAX) ─────────────────────────── */
  var cartDrawer = document.querySelector("cart-drawer");

  function bindQuickAdd(root) {
    (root || document).querySelectorAll("[data-quick-add]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var variantId = btn.getAttribute("data-quick-add");
        if (!variantId) return;
        var originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = "Adding…";

        var body = { items: [{ id: variantId, quantity: 1 }] };
        if (cartDrawer) {
          body.sections = cartDrawer.getSectionsToRender().map(function (section) { return section.id; });
          body.sections_url = window.location.pathname;
        }

        fetch(window.routes.cart_add_url + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(body)
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw err; });
            return r.json();
          })
          .then(function (item) {
            return fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
              document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
              if (cartDrawer && item.sections) {
                cartDrawer.renderContents(item);
              }
            });
          })
          .then(function () {
            btn.textContent = "Added";
            setTimeout(function () {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 1500);
          })
          .catch(function (err) {
            btn.textContent = (err && err.description) || "Unavailable";
            setTimeout(function () {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 1800);
          });
      });
    });
  }
  bindQuickAdd(document);

  /* ── Cart upsell popup ("Complete Your Order") ────────────
     Every add-to-cart on the site (product-form.js PDP submits AND the
     quick-add above) funnels through cartDrawer.renderContents(), since
     product-form.js resolves `this.cart` to this same <cart-drawer>
     singleton. Patching its prototype here — instead of forking Dawn's
     product-form.js — is what makes this popup fire from every add path.
     Suggestions come from sections/op76-cart-upsell.liquid, which reads
     the just-added product's `custom.upsell_collection` metafield (type:
     Collection reference — must be created in Admin). If that section
     renders no products (metafield unset/empty collection), the drawer
     opens exactly as before. */
  if (cartDrawer) {
    var CartDrawerCtor = customElements.get("cart-drawer");
    if (CartDrawerCtor) {
      var upsellModal = null;

      function extractUpsellModal(html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var modal = doc.getElementById("op76-cart-upsell");
        return modal && modal.querySelector(".cm-card") ? modal : null;
      }

      // Removes the popup with no side effects (no drawer open). Used both
      // when swapping in fresh popup content and as the first step of
      // CartDrawerCtor.prototype.open below, so popup and drawer can never
      // both be visible at once regardless of which one triggers first.
      function removeUpsellModal() {
        if (!upsellModal) return;
        var el = upsellModal;
        upsellModal = null;
        el.classList.remove("open");
        document.body.style.overflow = "";
        setTimeout(function () {
          if (el.parentNode) el.parentNode.removeChild(el);
        }, 300);
      }

      function openUpsellModal(freshModal) {
        removeUpsellModal();
        upsellModal = freshModal;
        upsellModal.hidden = false;
        document.body.appendChild(upsellModal);
        bindQuickAdd(upsellModal);
        // Closing the popup (X, scrim, "Keep Shopping", Escape) hands off to
        // the cart drawer rather than just dismissing.
        upsellModal.querySelectorAll("[data-cm-close]").forEach(function (el) {
          el.addEventListener("click", function () { cartDrawer.open(); });
        });
        requestAnimationFrame(function () { upsellModal.classList.add("open"); });
        document.body.style.overflow = "hidden";
      }

      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && upsellModal) cartDrawer.open();
      });

      var baseGetSectionsToRender = CartDrawerCtor.prototype.getSectionsToRender;
      CartDrawerCtor.prototype.getSectionsToRender = function () {
        return baseGetSectionsToRender.call(this).concat([{ id: "op76-cart-upsell" }]);
      };

      var baseOpen = CartDrawerCtor.prototype.open;
      CartDrawerCtor.prototype.open = function (triggeredBy) {
        removeUpsellModal();
        baseOpen.call(this, triggeredBy);
      };

      var baseRenderContents = CartDrawerCtor.prototype.renderContents;
      CartDrawerCtor.prototype.renderContents = function (parsedState) {
        var upsellHtml = parsedState.sections && parsedState.sections["op76-cart-upsell"];
        var freshModal = upsellHtml ? extractUpsellModal(upsellHtml) : null;
        if (freshModal) {
          // Same DOM sync Dawn's own renderContents does (see cart-drawer.js),
          // minus its trailing setTimeout(() => this.open()). That open() call
          // can't be suppressed by temporarily swapping this.open — it fires
          // inside Dawn's own setTimeout, which runs *after* this function
          // already returns and restores this.open, so the swap-back always
          // wins the race and the drawer flashes open over the popup. Skipping
          // the call here entirely (rather than racing it) is what makes the
          // popup take over instead of the drawer for this add.
          var self = this;
          var drawerInner = this.querySelector(".drawer__inner");
          if (drawerInner && drawerInner.classList.contains("is-empty")) {
            drawerInner.classList.remove("is-empty");
          }
          this.productId = parsedState.id;
          this.getSectionsToRender().forEach(function (section) {
            var sectionElement = section.selector
              ? document.querySelector(section.selector)
              : document.getElementById(section.id);
            if (!sectionElement) return;
            sectionElement.innerHTML = self.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          });
          openUpsellModal(freshModal);
        } else {
          baseRenderContents.call(this, parsedState);
        }
        scheduleResync(900);
        scheduleResync(2200);
      };
    }
  }

  /* ── Comparison table scroll hint ─────────────────────── */
  var compareWrap = document.querySelector(".op76-compare-wrap");
  var scrollHint = document.querySelector(".op76-scroll-hint");
  if (compareWrap && scrollHint) {
    compareWrap.addEventListener(
      "scroll",
      function () {
        if (compareWrap.scrollLeft > 12) scrollHint.style.display = "none";
      },
      { passive: true }
    );
  }

  /* ── Product bundle PDP: gallery slider ───────────────── */
  document.querySelectorAll(".op76-pb-gallery").forEach(function (g) {
    var slides = [].slice.call(g.querySelectorAll(".op76-pb-gslide"));
    var thumbs = [].slice.call(g.querySelectorAll(".op76-pb-thumb"));
    if (slides.length < 2 && thumbs.length < 2) return;
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle("active", k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle("active", k === i); });
    }
    thumbs.forEach(function (t, k) {
      t.addEventListener("click", function () { show(k); });
    });
    var prev = g.querySelector(".op76-pb-gprev");
    var next = g.querySelector(".op76-pb-gnext");
    if (prev) prev.addEventListener("click", function () { show(i - 1); });
    if (next) next.addEventListener("click", function () { show(i + 1); });
  });

  /* ── Product bundle PDP: quantity steppers ────────────── */
  document.querySelectorAll(".op76-qty").forEach(function (q) {
    var v = q.querySelector(".qval");
    var minus = q.querySelector(".qminus");
    var plus = q.querySelector(".qplus");
    if (!v) return;
    if (minus) minus.addEventListener("click", function () {
      v.value = Math.max(1, (parseInt(v.value, 10) || 1) - 1);
    });
    if (plus) plus.addEventListener("click", function () {
      v.value = (parseInt(v.value, 10) || 1) + 1;
    });
    v.addEventListener("input", function () {
      v.value = v.value.replace(/[^0-9]/g, "") || "1";
    });
  });

  /* ── Product bundle PDP: variant picker ───────────────── */
  document.querySelectorAll(".op76-pb-variants[data-variant-picker]").forEach(function (picker) {
    var dataEl = picker.querySelector("[data-variant-data]");
    var buybox = picker.closest(".op76-pb-buybox");
    var form = buybox ? buybox.querySelector(".op76-pb-form") : null;
    if (!dataEl || !buybox || !form) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var idInput = form.querySelector('input[name="id"]');
    var priceEl = buybox.querySelector("[data-pb-price]");
    var priceWrapEl = buybox.querySelector("[data-pb-price-wrap]");
    var priceCompareEl = buybox.querySelector("[data-pb-price-compare]");
    var reserveNoteEl = buybox.querySelector("[data-reserve-note]");
    var reserveNotePriceEl = buybox.querySelector("[data-reserve-note-price]");
    var addBtn = form.querySelector(".op76-pb-add");
    var addBtnLabel = addBtn ? addBtn.querySelector("span") : null;
    var addBtnDefaultLabel = addBtnLabel ? addBtnLabel.textContent : "";
    var groups = [].slice.call(picker.querySelectorAll(".op76-pb-variant-group"));

    function selectedOptions() {
      return groups.map(function (group) {
        var active = group.querySelector(".op76-pb-variant-opt.active");
        return active ? active.getAttribute("data-option-value") : null;
      });
    }

    function findVariant(selected) {
      return variants.filter(function (v) {
        return v.options.every(function (value, i) { return value === selected[i]; });
      })[0];
    }

    function applyVariant(variant) {
      if (idInput) idInput.value = variant ? variant.id : "";
      if (priceEl && variant) priceEl.innerHTML = variant.price_html;
      if (variant) {
        var onSale = !!variant.compare_at_price_html;
        if (priceWrapEl) priceWrapEl.classList.toggle("on-sale", onSale);
        if (priceCompareEl) {
          priceCompareEl.hidden = !onSale;
          if (onSale) priceCompareEl.innerHTML = variant.compare_at_price_html;
        }
      }

      var available = !!(variant && variant.available);
      if (addBtn) addBtn.disabled = !available;
      if (addBtnLabel) {
        addBtnLabel.textContent = !variant
          ? window.variantStrings.unavailable
          : available
            ? addBtnDefaultLabel
            : window.variantStrings.soldOut;
      }

      if (reserveNoteEl) {
        var isReserve = !!(variant && variant.options && variant.options.indexOf("Reserve") !== -1);
        reserveNoteEl.hidden = !isReserve;
        if (isReserve && reserveNotePriceEl) reserveNotePriceEl.innerHTML = variant.price_html;
      }
    }

    groups.forEach(function (group) {
      var opts = [].slice.call(group.querySelectorAll(".op76-pb-variant-opt"));
      opts.forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (btn.classList.contains("active")) return;
          opts.forEach(function (b) { b.classList.remove("active"); });
          btn.classList.add("active");
          applyVariant(findVariant(selectedOptions()));
        });
      });
    });
  });

  /* ── Product bundle PDP: delivery date ── */
  document.querySelectorAll(".op76-pb-date").forEach(function (wrap) {
    var input = wrap.querySelector(".op76-pb-dateinput");
    if (!input) return;
    input.addEventListener("change", function () {
      if (input.value) wrap.classList.remove("err");
    });
  });

  /* Block add-to-cart submit until a delivery date is chosen */
  document.querySelectorAll(".op76-pb-buybox form").forEach(function (form) {
    var wrap = form.querySelector(".op76-pb-date");
    var input = form.querySelector(".op76-pb-dateinput");
    if (!wrap || !input) return;
    form.addEventListener(
      "submit",
      function (e) {
        if (!input.value) {
          e.preventDefault();
          e.stopImmediatePropagation();
          wrap.classList.add("err");
          input.focus();
          try { input.showPicker && input.showPicker(); } catch (err) {}
        }
      },
      true
    );
  });

  /* ── Corporate gift catalog: level filter ── */
  document.querySelectorAll("[data-gift-filter]").forEach(function (wrap) {
    var cards = wrap.querySelectorAll(".op76-card");
    var chips = wrap.querySelectorAll(".op76-gift-chip");
    var empty = wrap.querySelector(".op76-gift-empty");
    function apply(level) {
      var shown = 0;
      cards.forEach(function (card) {
        var match = level === "all" || (card.getAttribute("data-level") || "").split(" ").indexOf(level) !== -1;
        card.hidden = !match;
        if (match) shown++;
      });
      chips.forEach(function (c) { c.classList.toggle("active", c.getAttribute("data-filter") === level); });
      if (empty) empty.hidden = shown > 0;
    }
    wrap.querySelectorAll("[data-filter]").forEach(function (btn) {
      btn.addEventListener("click", function () { apply(btn.getAttribute("data-filter")); });
    });
  });
})();
